Dom.addComponent(new class WidgetComponent extends AbstractComponent {

  constructor() {
    super({
      name: "widget",
      iframable: true,
      responsiveChildren: {
        width: false,
        height: false
      }
    });
  }

  // forcedHeight() {
  //   return !this.app._mini_widget ? "100%" : "670px";
  // }

  css() {
    return `GULP-CSS-FILE-WIDGET`;
  }

  html(props) {
    let classes = `slaask-hidden ${props.nativeSdk} ${props.rtl} ${props.sideClass} ${props.slaaskMiniClass} ${props.mobileClass}`.replace(/ +/g, " ").trim();
    return `
      <div class="${classes}" style="bottom: ${props.buttonSizeMargin}px;" role="dialog" aria-modal="true" aria-labelledby="slaask-widget-header-title-main">
        <style>
          .slaask-widget {
            background-image: linear-gradient(0deg, ${Utils.alphaHex(this.app._window_color, 0.05)} 0%, ${Utils.alphaHex(this.app._window_color, 0.1)} 50%, ${Utils.alphaHex(this.app._window_color, 0.15)} 100%);
          }
          .slaask-widget .slaask-widget-card {
              box-shadow: 0 8px 16px 0 #f6f7fb, 0 0px 4px 0 #f6f7fb, inset 0 2px 0 0 ${this.app._window_color};
              -webkit-box-shadow: 0 8px 16px 0 #f6f7fb, 0 0px 4px 0 #f6f7fb, inset 0 2px 0 0 ${this.app._window_color};
          }
          .slaask-messages li .ctext-wrap {
            background-color: ${this.app._chat_color};
          }
          .slaask-messages li .ctext-wrap .slaask-message-body {
            color: ${this.app._chat_text_color}!important;
          }
          .slaask-messages li .ctext-wrap .message-from-name i {
            color: ${this.app._chat_text_color}!important;
          }
          .slaask-messages li.odd .ctext-wrap {
            background-color: ${this.app._guest_chat_color};
            color: ${this.app._guest_chat_text_color}!important;
          }
          .slaask-messages li.odd .ctext-wrap p {
            color: ${this.app._guest_chat_text_color}
          }
          .slaask-messages li.odd .ctext-wrap p code {
            color: ${this.app._window_color};
            padding: 3px 8px;
            font-variant-ligatures: none;
            background-color: ${this.app._guest_chat_text_color};
            border: 0;
            box-shadow: 0 1px 2px 0 rgba(234, 236, 238, 0.8);
            border-radius: 8px;
          }
          .slaask-messages li.odd .ctext-wrap p a {
            color: ${this.app._guest_chat_text_color}
          }
          .slaask-messages li .ctext-wrap .main-slaask-submit {
            background: ${this.app._window_color}!important;
            color: ${this.app._guest_chat_text_color}
          }
          .slaask-messages li.odd .ctext-wrap pre {
            color: ${this.app._window_color};
            background-color: ${this.app._guest_chat_text_color};
          }
          .slaask-messages li .ctext-wrap p code {
            color: #d72b3f;
            padding: 2px 3px 1px;
            font-variant-ligatures: none;
            background-color: #f7f7f9;
            border: 1px solid #e1e1e8;
            border-radius: 3px;
          }
          .slaask-messages li .ctext-wrap p pre {
            margin: 0.5rem 0 0.2rem;
            font-size: 0.75rem;
            line-height: 1.15rem;
            padding: 0.5rem;
            font-variant-ligatures: none;
            word-break: normal;
            tab-size: 4;
            display: block;
            border: 1px solid #ccc
          }
          .slaask-messages li .ctext-wrap p a:hover, .slaask-messages li .ctext-wrap p a:active {
            cursor: pointer
          }
          .slaask-message .slaask-message-content .slaask-btn {
            border-color: ${this.app._window_color}!important;
            color: ${this.app._window_color}!important;
          }
          .slaask-widget .slaask-offline-form .slaask-input-offline:focus, .slaask-widget .slaask-input:focus, .slaask-widget .slaask-btn:focus {
            border-color: ${this.app._window_color}!important;
          }
          .slaask-faqs-item:hover{
            color: ${this.app._chat_text_color};
          }
          .asktech-input-attachment-layout .slaask-input + button {
            background-color: ${this.app._window_color};
            color: ${this.app._guest_chat_text_color};
            cursor: pointer;
          }
          .asktech-input-attachment-layout .slaask-input.asktech-empty + button {
            background-color: ${this.app._chat_color};
            color: ${Utils.alphaHex(this.app._chat_text_color, 0.3)};
            cursor: default;
          }
          #asktech-get-started .asktech-get-started-button {
            background-color: ${this.app._window_color};
            color: ${this.app._guest_chat_text_color};
          }
          .slaask-widget-homepage-custom-card .slaask-widget-homepage-cta,.slaask-widget-homepage-card .slaask-widget-homepage-cta { background-color: ${this.app._window_color}!important;color: ${this.app._title_color} } .slaask-widget-homepage-custom-card .slaask-widget-homepage-cta2,.slaask-widget-homepage-card .slaask-widget-homepage-cta2 { color: ${this.app._window_color}!important }

          /* Style pour l'indication visuelle du focus sur les boutons et conversations */
          #slaask-widget-homepage-conv-button:focus,
          #slaask-widget-homepage-conv-button:focus-visible,
          #slaask-widget-homepage-conv-button2:focus,
          #slaask-widget-homepage-conv-button2:focus-visible,
          .slaask-widget-convpage-conversation:focus,
          .slaask-widget-convpage-conversation:focus-visible,
          #slaask-widget-convpage-button:focus,
          #slaask-widget-convpage-button:focus-visible,
          .slaask-messages li:focus,
          .slaask-messages li:focus-visible {
            outline: none !important;
            box-shadow: none !important;
          }

          /* Style pour l'indication visuelle du focus sur les boutons d'en-tête */
          .slaask-widget-header-button:focus,
          .slaask-widget-header-button:focus-visible {
            outline: none !important;
            box-shadow: none !important;
          }

          /* Style spécifique pour la croix et le bouton éphemeral */
          #slaask-widget-header-cross:focus,
          #slaask-widget-header-cross:focus-visible,
          #slaask-widget-header-ephemeral:focus,
          #slaask-widget-header-ephemeral:focus-visible {
            opacity: 1 !important;
            visibility: visible !important;
          }

          #slaask-widget-header-video-call {
            position: relative;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          #slaask-widget-header-video-call .video-call-indicator {
            position: absolute;
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
            width: 8px;
            height: 8px;
            background-color: #2ed573;
            border-radius: 50%;
            border: 2px solid ${this.app._window_color};
            animation: blink 1.5s ease-in-out infinite;
            z-index: 1;
          }
          @keyframes blink {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.5;
              transform: scale(0.8);
            }
          }
        </style>
        <div id="slaask-widget-header" class="slaask-widget-header" style="background-color: ${this.app._window_color}!important; color: ${this.app._title_color}!important;">
          <div id="slaask-widget-header-back" class="slaask-widget-header-button slaask-widget-header-back" tabindex="0" role="button" aria-label="${Wording.back}">${Svg.back(this.app._title_color, 24)}</div>
          <div class="slaask-widget-header-title" id="slaask-widget-header-title" style="color: ${this.app._title_color}!important">
            <span id="slaask-widget-header-title-main" class="slaask-widget-header-title-main">${Emoji.emojify(Wording.window_title)}</span>
            <div id="slaask-widget-header-title-small" class="slaask-small slaask-widget-ellipsis" style="color: ${this.app._title_color}!important">
              ${Wording.homepage_subtitle}
            </div>
          </div>
          <div id="slaask-widget-header-cross" class="slaask-widget-header-button slaask-widget-header-cross" tabindex="0" role="button" aria-label="${Wording.close_button}">${Svg.cross(this.app._title_color, 16)}</div>
          <div id="slaask-widget-header-ephemeral" class="slaask-widget-header-button slaask-widget-header-ephemeral" tabindex="0" role="button" aria-label="${Wording.new_ephemeral_conversation_text}">${Svg.ephemeral(this.app._title_color, 12)}</div>
          <div id="slaask-widget-header-zoom-in" class="slaask-widget-header-button slaask-widget-header-zoom-in" tabindex="0" role="button" aria-label="${Wording.zoom_in}">${Svg.zoomIn(this.app._title_color, 18)}</div>
          <div id="slaask-widget-header-zoom-out" class="slaask-hidden slaask-widget-header-button slaask-widget-header-zoom-in" tabindex="0" role="button" aria-label="${Wording.zoom_out}">${Svg.zoomOut(this.app._title_color, 18)}</div>
          <div id="slaask-widget-header-video-call" class="slaask-widget-header-button slaask-widget-header-video-call slaask-hidden" tabindex="0" role="button" aria-label="${Wording.go_back_to_call}" title="${Wording.go_back_to_call}">
            ${Svg.call(this.app._title_color, 20)}
            <span class="video-call-indicator"></span>
          </div>
        </div>
        <div id="slaask-widget-notify-container" style="background-color: ${this.app._window_color}; border-top: 1px solid #FFF" class="slaask-widget-notify-container slaask-hidden">
          <div class="slaask-widget-notify-title" id="slaask-widget-notify-title">
            <span class="slaask-widget-notify-title-span-online" id="slaask-widget-notify-title-span" style="color: ${this.app._title_color}">${Wording.online_users_text} ${Wording.loading_button_value}</span>
          </div>
        </div>
        <div class="slaask-hidden slaask-widget-notify-container slaask-widget-notify-alert-container" id="slaask-widget-notify-alert-container" style="background: ${this.app._title_color}!important;">
          <div class="slaask-widget-notify-title" style="text-align:center">
            <span class="slaask-widget-notify-title-span" style="background: ${this.app._alert_background_color}!important; color: ${this.app._alert_text_color}!important" id="slaask-widget-notify-alert-title-span">
              Bla bla bla
            </span>
          </div>
        </div>
        <div id="slaask-widget-views-container" class="slaask-widget-views-container" style="${props.backgroundStyle}">
          <div id="slaask-widget-views-mover" class="slaask-widget-views-mover"></div>
        </div>
        <div id="slaask-menu-background-closer" class="slaask-hidden"></div>
        <div id="slaask-gifs-container" class="slaask-gifs-container slaask-gifs-container-hidden">
          <div class="slaask-gifs-input-icon">
            ${Svg.search('#888da8', '16px')}
          </div>
          <input type="text" id="slaask-gifs-input" class="slaask-gifs-input" placeholder="${Wording.homepage_helpcenter_placeholder}" autocomplete="off"/>
          <div id="slaask-gifs-subcontainer" class="slaask-gifs-subcontainer">
          </div>
        </div>
        <div id="slaask-emoji-container" class="slaask-gifs-container slaask-emoji-container slaask-emoji-container-hidden">
          <div class="slaask-gifs-input-icon">
            ${Svg.search('#888da8', '16px')}
          </div>
          <input type="text" id="slaask-emojis-input" class="slaask-gifs-input" placeholder="${Wording.homepage_helpcenter_placeholder}" autocomplete="off"/>
          <div id="slaask-gifs-subcontainer" class="slaask-gifs-subcontainer">
            ${EmojiPicker.buildHtml()}
          </div>
        </div>
        ${props.fileSharingMenu}
        <div id="slaask-widget-footer" class="slaask-widget-footer slaask-footer-hidden" aria-hidden="true" style="display: none;">
          <div id="slaask-whitelabel" class="slaask-whitelabel">
            ${this.app._whitelabel_html}
          </div>
        </div>
        <form autocomplete="off" class="slaask-form slaask-form-hidden" id="slaask-form" aria-hidden="true" style="display: none;">
          <textarea id="slaask-input" class="slaask-input-chat ${props.inputModuleClass}" value="" rows="1" placeholder="${props.placeholder}" />${this.app._typed_text}</textarea>
          <div class="slaask-input-buttons">
            ${props.emojiButton}
            ${props.gifButton}
            ${props.fileSharingButton}
            ${props.sendMessageHtml}
          </div>
        </form>
        <div id="asktech-get-started">
          <button class="asktech-get-started-button">
            <span>${Wording.get_started}</span>
          </button>
        </div>
        <div id="asktech-reconnecting">
          <div class="asktech-disconnected">
            <div class="asktech-reconnecting-title">${Wording.reconnecting_1}</div>
            <div class="asktech-reconnecting-subtitle">${Wording.reconnecting_2}</div>
            <div class="asktech-reconnecting-pulser"></div>
          </div>
          <div class="asktech-reconnected">
            <div class="asktech-reconnecting-button">${Wording.reconnect}</div>
          </div>
        </div>
      </div>
    `;
  }

  initEventListeners() {
    let getStartedButton = this.element.querySelector('#asktech-get-started .asktech-get-started-button');
    this._registerEvent(getStartedButton, 'click', () => {
      Conversations.userCommittedToNewConversation(true);
    });
    this._registerEvent(this.window, 'message', event => {
      if (event.data == "asktech_iframe_close" && Views.current.name == 'iframe') {
        Views.jumpToPrevious();
      }
    });
    
    const videoCallButton = Dom.findById('widget', 'slaask-widget-header-video-call');
    if (videoCallButton) {
      this._registerEvent(videoCallButton, 'click', () => {
        this.app._returnToDailyCall();
      });
    }

    const zoomInButton = Dom.findById('widget', 'slaask-widget-header-zoom-in');
    if (zoomInButton) {
      this._registerEvent(zoomInButton, 'click', () => {
        Dom.setWidgetSize('large', null, true);
        zoomInButton.classList.add('slaask-hidden');
        zoomOutButton.classList.remove('slaask-hidden');
      });
    }

    const zoomOutButton = Dom.findById('widget', 'slaask-widget-header-zoom-out');
    if (zoomOutButton) {
      this._registerEvent(zoomOutButton, 'click', () => {
        Dom.setWidgetSize('small', null, true);
        zoomInButton.classList.remove('slaask-hidden');
        zoomOutButton.classList.add('slaask-hidden');
      });
    }

    Dom.updateZoomButtons();
  }

  _iframePolyfills(iframeWindow) {
    super._iframePolyfills(iframeWindow);

    // Element.scroll (edited for requestAnimationFrame compatibility)
    (function() {
      function polyfill() {
        var f = iframeWindow,
          n = iframeWindow.document;
        if (!("scrollBehavior" in n.documentElement.style && !0 !== f.__forceSmoothScrollPolyfill__)) {
          var o, t = f.HTMLElement || f.Element,
            s = 468,
            p = {
              scroll: f.scroll || f.scrollTo,
              scrollBy: f.scrollBy,
              elementScroll: t.prototype.scroll || d,
              scrollIntoView: t.prototype.scrollIntoView
            },
            a = f.performance && f.performance.now ? f.performance.now.bind(f.performance) : Date.now,
            l = (o = f.navigator.userAgent, new RegExp(["MSIE ", "Trident/", "Edge/"].join("|")).test(o) ? 1 : 0);
          f.scroll = f.scrollTo = function() {
            void 0 !== arguments[0] && (!0 !== e(arguments[0]) ? c.call(f, n.body, void 0 !== arguments[0].left ? ~~arguments[0].left : f.scrollX || f.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : f.scrollY || f.pageYOffset) : p.scroll.call(f, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : f.scrollX || f.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : f.scrollY || f.pageYOffset))
          }, f.scrollBy = function() {
            void 0 !== arguments[0] && (e(arguments[0]) ? p.scrollBy.call(f, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : c.call(f, n.body, ~~arguments[0].left + (f.scrollX || f.pageXOffset), ~~arguments[0].top + (f.scrollY || f.pageYOffset)))
          }, t.prototype.scroll = t.prototype.scrollTo = function() {
            if (void 0 !== arguments[0])
              if (!0 !== e(arguments[0])) {
                var o = arguments[0].left,
                  t = arguments[0].top;
                c.call(this, this, void 0 === o ? this.scrollLeft : ~~o, void 0 === t ? this.scrollTop : ~~t)
              } else {
                if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value could not be converted");
                p.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
              }
          }, t.prototype.scrollBy = function() {
            void 0 !== arguments[0] && (!0 !== e(arguments[0]) ? this.scroll({
              left: ~~arguments[0].left + this.scrollLeft,
              top: ~~arguments[0].top + this.scrollTop,
              behavior: arguments[0].behavior
            }) : p.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop))
          }, t.prototype.scrollIntoView = function() {
            if (!0 !== e(arguments[0])) {
              var o = function(o) {
                  for (var t, l, e; !1 == ((o = o.parentNode) === n.body) && !1 === (l = r(t = o, "Y") && i(t, "Y"), e = r(t, "X") && i(t, "X"), l || e););
                  return o
                }(this),
                t = o.getBoundingClientRect(),
                l = this.getBoundingClientRect();
              o !== n.body ? (c.call(this, o, o.scrollLeft + l.left - t.left, o.scrollTop + l.top - t.top), "fixed" !== f.getComputedStyle(o).position && f.scrollBy({
                left: t.left,
                top: t.top,
                behavior: "smooth"
              })) : f.scrollBy({
                left: l.left,
                top: l.top,
                behavior: "smooth"
              })
            } else p.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0])
          }
        }

        function d(o, t) {
          this.scrollLeft = o, this.scrollTop = t
        }

        function e(o) {
          if (null === o || "object" != typeof o || void 0 === o.behavior || "auto" === o.behavior || "instant" === o.behavior) return !0;
          if ("object" == typeof o && "smooth" === o.behavior) return !1;
          throw new TypeError("behavior member of ScrollOptions " + o.behavior + " is not a valid value for enumeration ScrollBehavior.")
        }

        function r(o, t) {
          return "Y" === t ? o.clientHeight + l < o.scrollHeight : "X" === t ? o.clientWidth + l < o.scrollWidth : void 0
        }

        function i(o, t) {
          var l = f.getComputedStyle(o, null)["overflow" + t];
          return "auto" === l || "scroll" === l
        }

        function v(o) {
          var t, l, e, r, i = (a() - o.startTime) / s;
          r = i = 1 < i ? 1 : i, t = .5 * (1 - Math.cos(Math.PI * r)), l = o.startX + (o.x - o.startX) * t, e = o.startY + (o.y - o.startY) * t, o.method.call(o.scrollable, l, e), l === o.x && e === o.y || requestAnimationFrame(v.bind(f, o))
        }

        function c(o, t, l) {
          var e, r, i, s, c = a();
          o === n.body ? (r = (e = f).scrollX || f.pageXOffset, i = f.scrollY || f.pageYOffset, s = p.scroll) : (r = (e = o).scrollLeft, i = o.scrollTop, s = d), v({
            scrollable: e,
            method: s,
            startTime: c,
            startX: r,
            startY: i,
            x: t,
            y: l
          })
        }
      }
      "object" == typeof exports && "undefined" != typeof module ? module.exports = {
        polyfill: polyfill
      } : polyfill();
    })();
  }

});
